import braceletIcon from '../assets/productTypeIcons/bracelet.png';
import chainIcon from '../assets/productTypeIcons/chain.png';
import earringIcon from '../assets/productTypeIcons/earring.png';
import pendantIcon from '../assets/productTypeIcons/pendant.png';
import ringIcon from '../assets/productTypeIcons/ring.png';

const productTypeIconByAlias: Record<string, string> = {
  bracelet: braceletIcon,
  bracelets: braceletIcon,
  chain: chainIcon,
  chains: chainIcon,
  earring: earringIcon,
  earrings: earringIcon,
  'ear-ring': earringIcon,
  'ear-rings': earringIcon,
  'ear ring': earringIcon,
  'ear rings': earringIcon,
  pendant: pendantIcon,
  pendants: pendantIcon,
  ring: ringIcon,
  rings: ringIcon,
};

const normalizeProductTypeName = (value: string) =>
  value
    .trim()
    .toLowerCase()
    .replace(/[_]+/g, '-')
    .replace(/\s+/g, ' ');

export const getProductTypeIcon = (typeName?: string | null, fallbackUrl?: string) => {
  if (!typeName) return fallbackUrl;

  const normalized = normalizeProductTypeName(typeName);
  const hyphenated = normalized.replace(/\s+/g, '-');
  const compact = normalized.replace(/[\s-]+/g, '');

  return (
    productTypeIconByAlias[normalized] ||
    productTypeIconByAlias[hyphenated] ||
    productTypeIconByAlias[compact] ||
    fallbackUrl
  );
};
